export default "__VITE_ASSET__C5QQQl7O__"